<!--Filters Button-->
<div class="filters-main">
  <div class="filters-btn-ctnr">
    <ukg-button parent-icon="filter" [type]="'button'" [emphasis]="'mid'" [disabled]="isDisabled" (click)="toggleFilters()" translate
      data-automation="filters-show-button">
      COMMON.FILTER
    </ukg-button>
  </div>
  <!--Filters-->
  <div data-automation="filters-panel" style="float: right; height:100%">
      <ukg-task-drawer-container>
        <ukg-task-drawer #drawer width="520px" style="position: absolute; top: 0; right: 0;padding: 0 !important; " 
          heading="{{'COMMON.FILTER' | translate}}" 
          [hasResetButton]="true"
          [hasApplyButton]="true" 
          (ukgTaskDrawerResetButtonClicked)="resetFilter()"
          (ukgTaskDrawerApplyButtonClicked)="applyFilter()" 
          (ukgTaskDrawerWillOpen)="taskDrawerOpen()"
          (ukgTaskDrawerWillClose)="taskDrawerDidClosed()">
          <div class="filters-panel-content">
            <ng-content></ng-content>
          </div>
        </ukg-task-drawer>
      </ukg-task-drawer-container>
  </div>
</div>
